import { connect } from 'react-redux';
import {
  updateSort,
  updateSearchString,
  addUser,
  updateUser,
  deleteUser,
  fetchUsers,
  fetchUsersNext,
  fetchPermissions,
} from './user-management-actions';
import UserManagement from '../../components/user-management/user-management';

const mapDispatchToProps = {
  updateSort,
  updateSearchString,
  addUser,
  updateUser,
  deleteUser,
  fetchUsers,
  fetchUsersNext,
  fetchPermissions,
};

const mapStateToProps = state => ({
  menuVisible: state.header.menuVisible,
  activeSort: state.userManagement.activeSort,
  activeSearchString: state.userManagement.activeSearchString,
  activeServiceCenter: state.serviceCenter.activeServiceCenter,
  serviceCenters: state.user.serviceCenters,
  tableData: state.userManagement.data,
  isDataLoading: state.userManagement.isDataLoading,
  isNextDataLoading: state.userManagement.isNextDataLoading,
  next: state.userManagement.next,
  roles: state.userManagement.roles,
  deleteSuccess: state.userManagement.deleteSuccess,
  isDeleting: state.userManagement.isDeleting,
  addedUsers: state.userManagement.addedUsers,
  isAdding: state.userManagement.isAdding,
  isUpdating: state.userManagement.isUpdating,
  error: state.userManagement.error,
  permissions: state.userManagement.permissions,
});

export default connect(mapStateToProps, mapDispatchToProps)(UserManagement);

